/* eslint-disable @stripe-internal/embedded/no-restricted-globals */
import type {
  IAccessoryLayerInit,
  IAccessoryLayerResize,
} from './AccessoryLayerMessages';
import {setupMessagePortHandoff} from '../utils/messageChannel';

export const initAccessoryLayer = () => {
  const [deferredPort] = setupMessagePortHandoff<IAccessoryLayerInit>({
    messageReceiverDirection: 'to',
    messageReceiverType: 'accessory-layer-message',
    messageReceiverInitRequestType: 'initaccessorylayer',
  })();

  // The resize observer has to be in the same frame as the element being observed
  // https://bugzilla.mozilla.org/show_bug.cgi?id=1689099
  const resizeObserver = new ResizeObserver(async (entries) => {
    const {port} = await deferredPort;
    for (let i = 0; i < entries.length; i += 1) {
      const entry = entries[i];
      const style = getComputedStyle(entry.target);
      const message: IAccessoryLayerResize = {
        type: 'accessory-layer-message',
        requestType: 'resizeiframe',
        direction: 'from',
        values: {
          id: window.name,
          styles: {
            width: style.width,
            height: style.height,
          },
        },
      };
      port.postMessage(message);
    }
  });

  // Create an observer instance linked to the callback function
  const layerType = new URLSearchParams(location.hash.replace('#', '')).get(
    'layer_type',
  );

  const mutationObserver = new MutationObserver(
    async (mutationList: MutationRecord[]) => {
      const {port} = await deferredPort;

      for (let i = 0; i < mutationList.length; i += 1) {
        const mutation = mutationList[i];
        if (mutation.type === 'childList') {
          const addedElement =
            document.getElementById('root')?.firstElementChild;
          if (addedElement) {
            if (layerType === 'overlay') {
              const message: IAccessoryLayerResize = {
                type: 'accessory-layer-message',
                requestType: 'resizeiframe',
                direction: 'from',
                values: {
                  id: window.name,
                  styles: {
                    width: '100%',
                    height: '100%',
                    top: '0px',
                    left: '0px',
                    position: 'fixed',
                  },
                },
              };
              port.postMessage(message);
            } else {
              resizeObserver.observe(addedElement);
            }
          }
        }
      }
    },
  );

  // Start observing the target node for configured mutations
  mutationObserver.observe(document.getElementById('root')!, {
    childList: true,
  });
};
